<template>
  <div class="giftCard responsive-menu">
    <div class="responsive-menu__child">
      <PageHeader
        :pageHeader="listPageHeader"
        :links="[
          { name: 'home', label: 'Home' },
          { name: 'giftCards', label: 'GiftCards' },
        ]"
        :entity="entity"
        :hideAddButton="true"
      />
      <SearchTable :entity="entity" :sort="sort" @sortChangeEvent="updateSort"
        :pagination="pagination" @paginationChange="updatePagination" @initialFilterUpdate="updateInitialFilter"
        :initialFilter="initialFilter" />
    </div>
  </div>
</template>

<script>
import PageHeader from "@/components/PageHeader.vue";
import { listPageHeader } from "./inputs";
import SearchTable from "@/components/SearchTable.vue";
import Entities from "@/resources/Entities";
import { mapActions, mapGetters } from "vuex";

export default {
  name: "giftCards",
  data() {
    return {
      listPageHeader,
      entity: Entities.GIFTCARD,
    };
  },
  mounted: function () {
    this.setPageTitle("GiftCard");
  },
  components: {
    PageHeader,
    SearchTable,
  },
  computed: {
    ...mapGetters({
      sort: "giftCardModule/sort",
      pagination: "giftCardModule/pagination",
      initialFilter: "giftCardModule/initialFilter"
    }),
  },
  methods: {
    ...mapActions({
      updateSort: "giftCardModule/updateSort",
      updatePagination: "giftCardModule/updatePagination",
      updateInitialFilter: "giftCardModule/updateInitialFilter"
    }),
  }
};
</script>
